module.exports = __webpack_public_path__ + "static/cm_text_logo-3fd328e296e0b561c49fa3ef2b9a521d.png";